import React from 'react';
import { strings } from '/imports/strings';
import { useParams } from 'react-router';
import { Org, canListOrgs, modelClass } from '/imports/api/orgs';
import { timezoneOptions } from '/imports/options';
import { LoadingFlex } from '/imports/ui/LoadingFlex';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { Select } from '/imports/ui/Select';
import { Checkbox } from '/imports/ui/Checkbox';
import { ImageInput } from '/imports/ui/ImageInput';
import { PhoneInput } from '/imports/ui/PhoneInput';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { useMethod, useUser } from '/imports/hooks';
import { autoForm, formConfig } from '/imports/ui/AutoForm';
import { AddressInput } from '/imports/ui/AddressInput';

const orgPageClasses = [
  '[&_.hide]:hidden',
  '[&_form]:pb-24!',
  '[&_.field-group_.wrapper_.file-widget-thumb]:ml-0',
].join(' ');

export const OrgPage = () => {
  const user = useUser();
  const { _id } = useParams<any>();
  const isNew = _id === 'new';
  const [document, documentLoading] = isNew ? [undefined, false] : useMethod(modelClass.getMethod, _id as string);
  const form = formConfig<Org>([
    [{ field: 'active', input: { type: Checkbox } }],
    [
      { field: 'avatar', label: 'Icon (*aspect 1:1)', input: { type: ImageInput } },
      { field: 'logo', label: `${strings.Logo()} (*full logo)`, input: { type: ImageInput } }
    ],
    [],
    [
      { field: 'name' },
      { field: 'phone', input: { type: PhoneInput } },
      { field: 'website', label: strings.Website() },
    ],
    [
      { field: 'address', label: strings.Address(), input: { type: AddressInput } },
      // { field: 'address2', label: strings.Address2() },
    ],
    [{ field: 'timezone', label: strings.Timezone(), input: { type: Select, props: { options: timezoneOptions() } } }],
    [
      { field: 'billingAccessCode', label: strings.BillingAccessCode() },
      { field: 'projectChannel', label: 'Project Channel', input: { type: Select, props: { options: [{ value: 'affiliate', label: 'Affiliate' }, { value: 'dealer', label: 'Dealer' }] } } }
    ],
  ]);
  const [OrgForm] = autoForm({
    document,
    createMethod: modelClass.createMethod,
    updateMethod: modelClass.updateMethod,
    deleteMethod: modelClass.deleteMethod,
    form,
    defaultUpdate: { _id, active: true, country: 'US', timezone: timezoneOptions()[0].value, projectChannel: 'affiliate' },
    redirect: '/orgs',
  });
  const initialized = user && !documentLoading;
  if (!initialized) return <LoadingFlex />;
  if (!canListOrgs(user)) return <NotPermittedPage />;
  return (
    <Page className={`page ${orgPageClasses}${!initialized ? ' initializing' : ''}`}>
      <PageHeading
        left={<h1>{isNew ? `${strings.New()} ${strings.Organization()}` : `${strings.Edit()} ${strings.Organization()}`}</h1>}
      />
      <PageBody>
        {OrgForm}
      </PageBody>
    </Page>
  );
};